import { render, staticRenderFns } from "./UnbindProjectDomain.vue?vue&type=template&id=b94bdb92"
import script from "./UnbindProjectDomain.vue?vue&type=script&lang=js"
export * from "./UnbindProjectDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports